import React from 'react';
import { Box, Modal, Typography, IconButton, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Asset360ModalProps {
  open: boolean;
  handleClose: () => void;
  systemCode: string | null;
  assetInstanceId: string | null;
}

const Asset360Modal: React.FC<Asset360ModalProps> = ({ open, handleClose, systemCode, assetInstanceId }) => {
  const theme = useTheme();

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="360-view-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '75%',
          height: '75%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <IconButton
          data-cy="asset-360-close-btn"
          onClick={handleClose}
          sx={{ position: 'absolute', top: 10, right: 10, color: theme.palette.grey[700] }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ mb: 1 }}>
          360° Interior View
        </Typography>
        {systemCode && assetInstanceId && (
          <iframe
            src={`/iframe/${systemCode}/${assetInstanceId}/pano`}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="360 View"
          ></iframe>
        )}
      </Box>
    </Modal>
  );
};

export default Asset360Modal;
